export default __webpack_public_path__ + "static/media/switch.29ae1e9c.svg";